import React from "react";
import { Box } from "@mui/material";
import { assetImages } from "../../constants/assets";
import useWindowHeight from "../../hooks/window-size/use-window-height";
import useWindowWidth from "../../hooks/window-size/use-window-width";

const HeroImage = () => {
  const windowHeight = useWindowHeight();
  const windowWidth = useWindowWidth();
  const isMobile = windowWidth < 1050;

  if (isMobile) return null;

  const getHeroImage = () => {
    return windowHeight < 830 || windowWidth < 1350
      ? assetImages.heroFullImage
      : assetImages.heroImage;
  };

  return (
    <Box>
      <Box
        component="img"
        src={getHeroImage()}
        alt="Athlete"
        sx={{
          position: "absolute",
          bottom: windowHeight < 830 ? 40 : 0,
          right: {
            md: "-12%",
            xl: windowHeight < 830 || windowWidth < 1340 ? "-5%" : "0%",
            lg: windowHeight < 830 || windowWidth < 1340 ? "-10%" : "0%",
          },
          height: windowHeight < 830 || windowWidth < 1340 ? "90%" : "100vh",
          width: "auto",
          maxWidth: "none",
          objectFit: "contain",
          objectPosition: "bottom",
          zIndex: 1,
        }}
      />
    </Box>
  );
};

export default HeroImage;
